module.exports = __webpack_public_path__ + "static/media/ImgWord2.04008150.svg";